// extracted by mini-css-extract-plugin
export default {"button":"DefaultButton_button__e3RSS","icon":"DefaultButton_icon__e6nKd"};